import React, { useCallback, useEffect } from 'react'
import { getIn } from 'formik'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../components/Button'
import FacebookMediaUpload from '../../../../../ReusableFormFields/FacebookMediaUpload'
import SingleStoryPreview from '../../../../../../features/components/FacebookPreviews/CarouselInstagramStoriesPreview/SingleStoryPreview'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'

import {
  CALL_TO_ACTION,
  CUSTOMIZED_STORY_FILE,
  FB_PAGE_CHOICE,
  FB_SPONSOR_PAGE_ID,
  IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY
} from '../../../fields'
import { FILE_URL, IMAGE_HASH } from '../../../../../ReusableFormFields/AdFileUpload/fields'

import useStyles from '../../../../../../styles/common/stepForms'
import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const recommendedSize = '1080 x 1920 px'

const stepFields = [CUSTOMIZED_STORY_FILE, IMAGE_HASH]
const itemPath = CUSTOMIZED_STORY_FILE

const CustomizedMediaStep = ({ formik, handleStepChange, isActive }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values, errors, touched, setFieldValue } = formik

  const item = getIn(values, itemPath)

  const fileUrlError = getIn(errors, itemPath + `.${FILE_URL}`)
  const fileUrlTouched = getIn(touched, itemPath + `.${FILE_URL}`)

  const mediaUrlError = fileUrlTouched && fileUrlError

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  useEffect(() => {
    if (isActive) {
      setFieldValue(IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY, true)
    } else {
      setFieldValue(IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY, false)
    }
  }, [isActive, setFieldValue])

  return (
    <>
      <div className={classes.stepTitle}>{t('Select images or videos')}</div>
      <div className={classes.stepBody}>
        <SingleStoryPreview
          pageId={values[FB_PAGE_CHOICE]}
          sponsorPageId={values[FB_SPONSOR_PAGE_ID]}
          mediaFile={values[CUSTOMIZED_STORY_FILE]}
          actionValue={values[CALL_TO_ACTION]}
        />
        <section className={drawerFormClasses.section}>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Image or video')}</h3>
          <FacebookMediaUpload
            formik={formik}
            item={item}
            itemPath={itemPath}
            isItemActive={isActive}
            mediaUrlError={mediaUrlError}
            recommendedSize={recommendedSize}
          />
          {errors[IMAGE_HASH] && <ErrorMessage error={errors[IMAGE_HASH]} />}
        </section>
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default CustomizedMediaStep
